module.exports = __webpack_public_path__ + "media/images/powered_by_stripe-4bcc2ea3234e92749d75fd9900265e04.png";